import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=2691a561&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=2691a561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691a561",
  null
  
)

export default component.exports